import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { HeaderSocialItemBlockConfig } from '@front-platform/content-builder';
import { headerSocialItemBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface HeaderSocialItemBlockRuntimeConfig {}

export type HeaderSocialItemBlockConfigInput = Partial<
  Omit<HeaderSocialItemBlockConfig, keyof HeaderSocialItemBlockRuntimeConfig> &
    HeaderSocialItemBlockRuntimeConfig
>;
export type HeaderSocialItemBlockResolvedConfig = Omit<
  HeaderSocialItemBlockConfig,
  keyof HeaderSocialItemBlockRuntimeConfig
> &
  Partial<HeaderSocialItemBlockRuntimeConfig>;
export interface HeaderSocialItemBlockContract extends ConfigComponentContract<
  HeaderSocialItemBlockConfigInput,
  HeaderSocialItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-header-social-item-block',
  templateUrl: './header-social-item-block.component.html',
  standalone: false,
})
export class HeaderSocialItemBlockComponent implements HeaderSocialItemBlockContract {
  readonly config = input<HeaderSocialItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    HeaderSocialItemBlockConfig,
    HeaderSocialItemBlockRuntimeConfig
  >(headerSocialItemBlockResolveConfig, () => ({ config: this.config() }));
  get item(): string | undefined {
    return this.resolvedConfig()['item'] as unknown as string | undefined;
  }
  get linkUrl(): string | undefined {
    return this.resolvedConfig()['link_url'] as unknown as string | undefined;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(HeaderSocialItemBlockComponent, { 'keyAliases': {} });
